import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
});

export const sectionHeading = css({
  fontSize: 'md',
  fontWeight: '700',
  color: 'hpxBlue600',
});

export const specialOfferCard = css({
  marginBottom: '2x',
});

export const specialOfferHeading = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'xs',
  fontWeight: '700',
  fontSize: 'md',
  color: 'hpxBlue600',
  marginBottom: 'xs',
});

export const specialOfferBody = css({
  fontSize: 'sm',
});

export const totalAmount = css({
  fontSize: 'hero',
  fontWeight: '700',
  color: 'hpxTeal500',
  lineHeight: '1.2',
});

export const totalLabel = css({
  fontSize: 'sm',
  color: 'hpxBlue600',
  fontWeight: '700',
  marginBottom: '1x',
});

export const summaryRow = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingY: 'xs',
  fontSize: 'sm',
});

export const summaryLabel = css({
  color: 'hpxGrey600',
});

export const summaryValue = css({
  fontWeight: '700',
  color: 'hpxBlue600',
});

export const feeGroupTitle = css({
  fontWeight: '700',
  fontSize: 'sm',
  color: 'hpxBlue600',
  marginTop: '2x',
  marginBottom: '1x',
});

export const feeRow = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingY: '1x',
  fontSize: 'sm',
});

export const feeLabel = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
  color: 'hpxBlue600',
});

export const feeAmount = css({
  fontWeight: '400',
  color: 'hpxBlue600',
});

export const feeNote = css({
  fontSize: 'tiny',
  color: 'hpxGrey600',
  marginTop: '0',
});

export const estimatedTotal = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingTop: '2x',
  fontSize: 'md',
  fontWeight: '700',
  color: 'hpxTeal500',
});

export const leaseTermsText = css({
  fontSize: 'sm',
  color: 'hpxBlue600',
  marginTop: 'xs',
  lineHeight: '1.5',
});

export const checkbox = css({
  width: '18px',
  height: '18px',
  accentColor: '#007a70',
  cursor: 'pointer',
});

export const subcardsContainer = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
});

export const disclaimerContainer = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
  marginTop: '2x',
});

export const disclaimer = css({
  fontSize: 'tiny',
  fontWeight: '400',
  color: 'hpxGrey600',
  lineHeight: '1.4',
});
